'use client';
import Typography from '@/components/shared/typography/typography.component';
import { FilterDisplayItemData } from '@/types/filters';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from '@/hook';
import { GreenTick } from '../../../../public/Images';

import classes from './styles.module.scss';

interface DropdownItemInterface {
    text: string | number;
    selected: boolean;
}
const FromToSelect = ({
    placeHolder,
    data,
    fromToValueChnaged,
    fromToValues,
}: {
    placeHolder: string;
    data: FilterDisplayItemData[];
    fromToValues: number[];
    fromToValueChnaged: (text: number[]) => void;
}) => {
    const { t } = useTranslation();
    const [focusedFrom, setFocusedFrom] = useState(false);
    const fromRef = useRef(null);
    const [focusedTo, setFocusedTo] = useState(false);
    const [fromData, setFromData] = useState<DropdownItemInterface[]>();
    const [toData, setToData] = useState<DropdownItemInterface[]>([]);
    const [valueFrom, setValueFrom] = useState<string | number>(
        fromToValues[0]
    );
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [valueTo, setValueTo] = useState<string | number>(fromToValues[1]);
    const toRef = useRef(null);
    useEffect(() => {
        document.addEventListener('click', handleClickOutside);

        return () => {
            //Remove the listener
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    const resetAllData = (fromObjectArr: DropdownItemInterface[]) => {
        setValueFrom('');
        setFromData(fromObjectArr);
        setToData([]);
    };

    useEffect(() => {
        const fromObjectArr: DropdownItemInterface[] = data.map(item => {
            return { text: item.text, selected: false };
        });
        setFromData(fromObjectArr);
        if (fromToValues[0]) {
            intiateToValue(
                { text: fromToValues[0], selected: true },
                fromObjectArr
            );
        } else {
            resetAllData(fromObjectArr);
        }
    }, [data, fromToValues]);

    const handleClickOutside = (event: any) => {
        const path = event.path || (event.composedPath && event.composedPath());

        if (!path.includes(fromRef.current)) {
            setFocusedFrom(false);
        }
        if (!path.includes(toRef.current)) {
            setFocusedTo(false);
        }
    };
    const intiateToValue = (
        selectedItem: DropdownItemInterface,
        intialData: DropdownItemInterface[]
    ) => {
        const toArr: DropdownItemInterface[] = [];
        const modifiedFromArr = intialData?.map(item => {
            if (item.text >= selectedItem.text) toArr.push(item);
            return { ...item, selected: item.text === selectedItem.text };
        });

        setValueFrom(selectedItem.text);
        setFromData(modifiedFromArr);
        setToData(toArr);
    };
    const fromItemCLicked = (selectedItem: DropdownItemInterface) => {
        const toArr: DropdownItemInterface[] = [];
        const modifiedFromArr = fromData?.map(item => {
            if (item.text >= selectedItem.text) toArr.push(item);
            return { ...item, selected: item.text === selectedItem.text };
        });
        setValueTo('');
        setValueFrom(selectedItem.text);
        setFromData(modifiedFromArr);

        fromToValueChnaged([Number(selectedItem.text)]);
        setToData(toArr);
    };
    const toItemCLicked = (selectedItem: DropdownItemInterface) => {
        const modifiedFromArr = toData?.map(item => {
            return { ...item, selected: item.text === selectedItem.text };
        });
        setToData(modifiedFromArr);
        setValueTo(selectedItem.text);
        fromToValueChnaged([Number(valueFrom), Number(selectedItem.text)]);
    };
    return (
        <div className={classes.container}>
            <div className={classes.container__input_group}>
                <Typography
                    className={classes.container__input_group__label}
                    variant="body2Medium"
                >
                    {t('From')}
                </Typography>
                <div className={classes.container__input_group__select_group}>
                    <input
                        readOnly
                        onFocus={() => setFocusedFrom(true)}
                        value={fromToValues[0] ? fromToValues[0] : ''}
                        ref={fromRef}
                        placeholder={placeHolder}
                        className={
                            classes.container__input_group__select_group__input
                        }
                    ></input>
                    {focusedFrom && (
                        <div
                            className={
                                classes.container__input_group__select_group__input__dropdown
                            }
                        >
                            {fromData &&
                                fromData.map(item => (
                                    <div
                                        onClick={() => fromItemCLicked(item)}
                                        key={item.text}
                                        className={
                                            classes.container__input_group__select_group__input__dropdown__item
                                        }
                                    >
                                        <Typography
                                            className={
                                                classes.container__input_group__select_group__input__dropdown__item__text
                                            }
                                            variant={'body1'}
                                        >
                                            {item.text}
                                        </Typography>
                                        {item.selected && (
                                            <img
                                                src={GreenTick.src}
                                                alt="selected"
                                                className={
                                                    classes.container__input_group__select_group__input__dropdown__item__tick
                                                }
                                            />
                                        )}
                                    </div>
                                ))}
                        </div>
                    )}
                </div>
            </div>
            <div className={classes.container__input_group}>
                <Typography
                    variant={'body2Medium'}
                    className={classes.container__input_group__label}
                >
                    {t('To')}
                </Typography>
                <div className={classes.container__input_group__select_group}>
                    <input
                        readOnly
                        onFocus={() => setFocusedTo(true)}
                        value={fromToValues[1] ? fromToValues[1] : ''}
                        disabled={toData?.length === 0}
                        ref={toRef}
                        placeholder={placeHolder}
                        className={
                            classes.container__input_group__select_group__input
                        }
                    ></input>
                    {focusedTo && (
                        <div
                            className={
                                classes.container__input_group__select_group__input__dropdown
                            }
                        >
                            {toData &&
                                toData.map(item => (
                                    <div
                                        onClick={() => toItemCLicked(item)}
                                        key={item.text}
                                        className={
                                            classes.container__input_group__select_group__input__dropdown__item
                                        }
                                    >
                                        <Typography
                                            className={
                                                classes.container__input_group__select_group__input__dropdown__item__text
                                            }
                                            variant={'body1'}
                                        >
                                            {item.text}
                                        </Typography>
                                        {item.selected && (
                                            <img
                                                src={GreenTick.src}
                                                alt="selected"
                                                className={
                                                    classes.container__input_group__select_group__input__dropdown__item__tick
                                                }
                                            />
                                        )}
                                    </div>
                                ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FromToSelect;
